import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Clock, X } from "lucide-react";
import { getRecentlyViewed, clearRecentlyViewed } from "@/lib/recentlyViewed";

function fmtDate(iso) {
  try {
    return new Date(iso).toLocaleDateString("en-US", {
      year: "numeric", month: "short", day: "numeric",
    });
  } catch { return iso || ""; }
}

export default function RecentlyViewedStrip({ excludeSlug = null }) {
  const [items, setItems] = useState([]);

  useEffect(() => {
    setItems(getRecentlyViewed().filter((p) => p.slug !== excludeSlug));
  }, [excludeSlug]);

  if (items.length === 0) return null;

  const onClear = () => { clearRecentlyViewed(); setItems([]); };

  return (
    <section
      data-testid="recently-viewed-strip"
      className="mb-14"
      aria-labelledby="recent-heading"
    >
      <div className="flex items-baseline justify-between mb-5 flex-wrap gap-3">
        <div className="flex items-center gap-3">
          <Clock className="w-4 h-4 bb-gold" />
          <h2 id="recent-heading" className="overline-gold">
            Pick up where you left off
          </h2>
        </div>
        <button
          type="button"
          onClick={onClear}
          data-testid="recently-viewed-clear"
          className="inline-flex items-center gap-1.5 text-xs uppercase tracking-wider bb-ink-soft hover:bb-ink transition-colors"
        >
          <X className="w-3 h-3" /> Clear
        </button>
      </div>

      <div className="flex gap-4 overflow-x-auto pb-3 -mx-2 px-2 snap-x snap-mandatory">
        {items.map((p) => (
          <Link
            key={p.slug}
            to={`/blog/${p.slug}`}
            data-testid={`recently-viewed-${p.slug}`}
            className="group snap-start shrink-0 w-[260px] bg-[#FAF6E8] border border-[#D9CFA0] rounded-lg overflow-hidden hover:shadow-md transition-shadow"
          >
            {p.hero_image && (
              <div className="aspect-[16/10] overflow-hidden bg-[#F2EBD3]">
                <img
                  src={p.hero_image}
                  alt=""
                  loading="lazy"
                  className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
                />
              </div>
            )}
            <div className="p-4">
              <div className="text-[10px] uppercase tracking-wider bb-ink-soft mb-2 font-light">
                {fmtDate(p.published_at)}{p.read_minutes ? ` · ${p.read_minutes} min read` : ""}
              </div>
              <h3 className="font-serif text-base bb-ink font-light leading-snug line-clamp-3 group-hover:text-[#C9A65A] transition-colors">
                {p.title}
              </h3>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}
